import { render } from "./EmployeeBulkUpload.vue?vue&type=template&id=f6124d10&scoped=true"
import script from "./EmployeeBulkUpload.vue?vue&type=script&lang=js"
export * from "./EmployeeBulkUpload.vue?vue&type=script&lang=js"

import "./EmployeeBulkUpload.vue?vue&type=style&index=0&id=f6124d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6124d10"]])

export default __exports__